import { useQuery } from '@tanstack/react-query';
import dayjs from 'dayjs';
import { Link } from 'react-router-dom';

import { cn } from '@/lib/utils';
import { getDashboardRecentIssuesQueryOptions } from '@/queries/dashboard';
import { getWorkspaceRoute } from '@/utils/routes';

export const RecentIssues = () => {
  const { data: response, isLoading: loading } = useQuery(getDashboardRecentIssuesQueryOptions());
  const data = response?.issues ?? [];

  return (
    <div className="flex h-full w-full flex-col gap-[20px]">
      <div className="flex flex-col">
        <span className="text-xl leading-[30px] font-medium">New Issues</span>
        <span className="text-secondary-text text-xs leading-[18px] font-normal">List of the most recent issues reported</span>
      </div>
      <div className="min-h-0 flex-1 overflow-y-auto pr-2">
        <div>
          {loading ? (
            <></>
          ) : (
            data.map((issue, i) => {
              const detail = [issue.type, issue.issue].filter(Boolean).join(': ');

              return (
                <div
                  className={cn(i !== data.length - 1 && 'flex flex-col border-b-[1px] border-solid border-[#E0E2E4] pb-[9px]', i > 0 && 'pt-[9px]')}
                  key={i}>
                  <div className="flex items-center justify-between gap-2">
                    <Link
                      to={getWorkspaceRoute(`/assets/${issue.asset.id}`)}
                      title={issue.asset.label}
                      className="min-w-0 truncate text-sm/[21px] font-bold !text-[#2E3940]">
                      {issue.asset.label}
                    </Link>
                    <span className="text-secondary-text shrink-0 text-xs/[18px] font-normal whitespace-nowrap">{dayjs(issue.createdAt).fromNow()}</span>
                  </div>
                  {detail ? <span className="text-xs/[21px] font-normal">{detail}</span> : null}
                </div>
              );
            })
          )}
        </div>
      </div>
    </div>
  );
};
